
import styles from './newsForm.module.css';

const ImageInput = ({
    id,
    label,
    multiple = false,
    onChange,
    previewUrls,
  }: {
    id: string;
    label: string;
    multiple?: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    previewUrls?: string[];
  }) => (
    <div className={styles.formGroup}>
      {label && <label htmlFor={id} className={styles.label}>{label}</label>}
      <input type="file" id={id} accept="image/*" multiple={multiple} onChange={onChange} />
      {previewUrls && previewUrls.length > 0 && (
        <div className={styles.imagePreviewContainer}>
          <p>Previews:</p>
          {previewUrls?.map((url, idx) => (
            <img key={`${id}-preview-${idx}`} src={url} alt={`Preview ${idx}`} className={styles.imagePreview} />
          ))}
        </div>
      )}
    </div>
  );

  export default ImageInput